(() => {
  const digitBlockStarts = [
    0x0660, 0x06f0, 0x0966, 0x09e6, 0x0a66, 0x0ae6, 0x0b66, 0x0be6,
    0x0c66, 0x0ce6, 0x0d66, 0x0e50, 0x0ed0, 0x0f20, 0x1040, 0x17e0, 0xff10,
  ];
  const digitPattern = /[٠-٩۰-۹०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯๐-๙໐-໙༠-༩၀-၉០-៩０-９]/g;
  const separatorPattern = /[٫٬]/g;
  const ignoredParents = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE', 'CODE', 'PRE']);
  const localizedAttributes = ['aria-label', 'placeholder', 'title', 'data-label'];

  const toAscii = (value) => {
    if (!value || (!digitPattern.test(value) && !separatorPattern.test(value))) return value;
    digitPattern.lastIndex = 0;
    separatorPattern.lastIndex = 0;

    return value
      .replace(digitPattern, (digit) => {
        const codePoint = digit.codePointAt(0);
        const blockStart = digitBlockStarts.find((start) => codePoint >= start && codePoint <= start + 9);
        return blockStart === undefined ? digit : String(codePoint - blockStart);
      })
      .replace(separatorPattern, (separator) => (separator === '٫' ? '.' : ','));
  };

  const normalizeElement = (element) => {
    localizedAttributes.forEach((attribute) => {
      const value = element.getAttribute(attribute);
      const normalized = toAscii(value);
      if (normalized !== value) element.setAttribute(attribute, normalized);
    });
  };

  const normalizeNode = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      if (root.parentElement && !ignoredParents.has(root.parentElement.tagName)) {
        const normalized = toAscii(root.nodeValue);
        if (normalized !== root.nodeValue) root.nodeValue = normalized;
      }
      return;
    }

    if (!(root instanceof Element) || ignoredParents.has(root.tagName)) return;
    normalizeElement(root);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    let current;
    while ((current = walker.nextNode())) {
      if (current.nodeType === Node.TEXT_NODE) {
        if (current.parentElement && !ignoredParents.has(current.parentElement.tagName)) {
          const normalized = toAscii(current.nodeValue);
          if (normalized !== current.nodeValue) current.nodeValue = normalized;
        }
      } else if (!ignoredParents.has(current.tagName)) {
        normalizeElement(current);
      }
    }
  };

  const configureAcceleratedCheckout = (root = document) => {
    if (!document.documentElement.lang.toLowerCase().startsWith('ar')) return;

    const elements = [];
    if (root instanceof Element && root.matches('shopify-accelerated-checkout, shopify-accelerated-checkout-cart')) {
      elements.push(root);
    }
    if (root.querySelectorAll) {
      elements.push(...root.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart'));
    }

    elements.forEach((element) => element.setAttribute('buyer-locale', 'ar-MA'));
  };

  const start = () => {
    normalizeNode(document.body);
    configureAcceleratedCheckout(document);

    if (document.documentElement.lang.toLowerCase().startsWith('ar')) {
      const configureCheckoutForm = (form) => {
        if (!(form instanceof HTMLFormElement)) return;

        const action = new URL(form.action, window.location.origin);
        action.searchParams.set('locale', 'ar-MA');
        form.action = action.toString();

        let localeInput = form.querySelector('input[name="locale"]');
        if (!localeInput) {
          localeInput = document.createElement('input');
          localeInput.type = 'hidden';
          localeInput.name = 'locale';
          form.appendChild(localeInput);
        }
        localeInput.value = 'ar-MA';
      };

      document.querySelectorAll('[name="checkout"]').forEach((button) => configureCheckoutForm(button.form));
      document.addEventListener(
        'click',
        (event) => {
          const checkoutButton = event.target.closest?.('[name="checkout"]');
          if (checkoutButton) configureCheckoutForm(checkoutButton.form);
        },
        true
      );
      document.addEventListener(
        'submit',
        (event) => {
          const form = event.target;
          if (form instanceof HTMLFormElement && form.querySelector('[name="checkout"]')) {
            configureCheckoutForm(form);
          }
        },
        true
      );
      document.addEventListener(
        'click',
        (event) => {
          const acceleratedCheckout = event
            .composedPath()
            .find((node) => node instanceof Element && node.matches('shopify-accelerated-checkout, shopify-accelerated-checkout-cart'));
          if (!acceleratedCheckout) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (acceleratedCheckout.matches('shopify-accelerated-checkout-cart')) {
            window.location.assign('/checkout?locale=ar-MA');
            return;
          }

          try {
            const variants = JSON.parse(acceleratedCheckout.getAttribute('variant-params') || '[]');
            const variantId = variants[0]?.id;
            if (!variantId) return;
            const productForm = acceleratedCheckout.closest('product-form-component, form')?.querySelector('form') || acceleratedCheckout.closest('form');
            const quantity = Math.max(1, Number(productForm?.querySelector('[name="quantity"]')?.value || 1));
            window.location.assign(`/cart/${variantId}:${quantity}?checkout&locale=ar-MA`);
          } catch (error) {
            window.location.assign('/checkout?locale=ar-MA');
          }
        },
        true
      );
    }

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') normalizeNode(mutation.target);
        mutation.addedNodes.forEach((node) => {
          normalizeNode(node);
          configureAcceleratedCheckout(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });

    document.addEventListener(
      'input',
      (event) => {
        const field = event.target;
        if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
        const normalized = toAscii(field.value);
        if (normalized !== field.value) field.value = normalized;
      },
      true
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
